import { useEffect, useState } from "react";
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from "../../../component/common/button/ExcelDownload.jsx";
import PopupDataGrid from "../../../component/common/popup/PopupDataGrid.jsx";

import '../../../css/data-grid.css';

const Intype_popup = () => {
    const [data, setData] = useState([{}]);

    const head = ['기관명', '의무기록번호', '내원일시', '손상발생일시']; //component화 

    const head_column = ['TRMSEMNM', 'TRMSIDNO', 'TRMSINDTM', 'TRMSHUDTM'];

    const excelhead = ['기관명', '의무기록번호', '내원일시', '손상발생일시'];
    const excelhead_column = ['TRMSEMNM', 'TRMSIDNO', 'TRMSINDTM', 'TRMSHUDTM'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('useTimeData'));

    const [loading, setLoading] = useState(false);

    const popupData = async () => {
        try {

            const response = await axios.get('/trmsapi/patientstat/bdtongtrms_stat_to_come_hospital_use_time_popup_data.do',
                { params: sendData }
            );
            setData(response.data);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    const flag = sendData.flag;

    return (
        <div className={`popup_container ${flag === 'ptmi' ? 'bg_st_bg' : flag === 'trms' ? 'bg_tr_bg' : ''}`}>
            <div className='flex justify-between'>
                <h4 className='sub_title w-70'>데이터 목록 - 환자정보</h4>
                {data.length === 0 ? '' :
                    <div className='btn_container mt-3'>
                        <ExcelDownload excelHead={excelhead} searched={isSearched} excelData={data} dataCode={excelhead_column} excelFileName={'환자 데이터'} />
                    </div>
                }
            </div>
            {loading ? <Loading /> :
                <PopupDataGrid
                    dataHead={head}
                    dataColumn={head_column}
                    dataList={data}
                    flag={flag} />
            }
        </div>
    )
}

export default Intype_popup;